/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBookingParallelSlots200, GetApiBookingParallelSlotsQueryParams, GetApiBookingParallelSlotsQueryResponse } from "../entities/GetApiBookingParallelSlots";
import { modelsParallelAvailableSlotsResponseSchema } from "./models/parallelAvailableSlotsResponseSchema";
import { z } from "zod/v4";

export const getApiBookingParallelSlotsQueryParamsSchema = z.object({
    "parent_service_id": z.coerce.number().int().describe("ID услуги родителя"),
"child_service_id": z.coerce.number().int().describe("ID услуги ребенка"),
"parent_barber_id": z.optional(z.coerce.number().int().describe("ID мастера-родителя")),
"child_barber_id": z.optional(z.coerce.number().int().describe("ID мастера-ребенка")),
"date": z.optional(z.string().describe("Дата (YYYY-MM-DD)")),
"branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiBookingParallelSlotsQueryParams>

/**
 * @description OK
 */
export const getApiBookingParallelSlots200Schema = z.lazy(() => modelsParallelAvailableSlotsResponseSchema) as unknown as z.ZodType<GetApiBookingParallelSlots200>

export const getApiBookingParallelSlotsQueryResponseSchema = z.lazy(() => getApiBookingParallelSlots200Schema) as unknown as z.ZodType<GetApiBookingParallelSlotsQueryResponse>